"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorTransportParametersTransformations = void 0;
const lodash_1 = __importDefault(require("lodash"));
exports.ActorTransportParametersTransformations = {
    Project: {
        projectName: (projectProfileView, index) => lodash_1.default.isEmpty(projectProfileView.projectName) ? `Project ${index + 1}` : projectProfileView.projectName
    }
};
